// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3K1Fv","ranges":"BmiRanges_ranges__39wL6"};